var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.0546C18 4.0536 13.971 0 9 0C4.029 0 0 4.0536 0 9.0546C0 13.575 3.2904 17.3208 7.5936 18V11.6724H5.3088V9.054H7.5936V7.0596C7.5936 4.7904 8.937 3.5364 10.9932 3.5364C11.9772 3.5364 13.008 3.7134 13.008 3.7134V5.9418H11.8722C10.7544 5.9418 10.4064 6.6402 10.4064 7.3566V9.0546H12.9024L12.5034 11.6718H10.4064V18C14.7096 17.3208 18 13.575 18 9.0546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube);
export default __webpack_public_path__ + "static/media/tube.48602bd206ad4686e29a391feec8fafd.svg";
export { ForwardRef as ReactComponent };